// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles__loading___3dQfe","building":"styles__building___3kkcs"};